module.exports = __webpack_public_path__ + "static/media/solarbombIcon.d8f46b97.svg";